import { CABIN_CLASS_ORDER } from "./constants.js";
const MIN_FARES_IN_SUMMARY = 2;
export const getBrandedFaresEligableForSummary = (brandedFares = []) => {
    const lowestCabinClass = brandedFares[0]?.brandedFareInfo?.cabinClass;
    if (!lowestCabinClass)
        return undefined;
    let eligableFares = brandedFares.filter((fare) => lowestCabinClass === fare.brandedFareInfo.cabinClass);
    if (eligableFares.length >= MIN_FARES_IN_SUMMARY)
        return eligableFares;
    const eligableCabinClasses = getCurrentAndNextCabinClass(lowestCabinClass);
    eligableFares = brandedFares.filter((fare) => eligableCabinClasses.includes(fare.brandedFareInfo.cabinClass || ""));
    if (eligableFares.length >= MIN_FARES_IN_SUMMARY)
        return eligableFares;
    return undefined;
};
const getCurrentAndNextCabinClass = (cabinClass) => {
    const cabinClassIndex = CABIN_CLASS_ORDER.indexOf(cabinClass);
    return CABIN_CLASS_ORDER.slice(cabinClassIndex, cabinClassIndex + 2);
};
